var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTissue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2094E8;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.9,363.3c-17.3-65-44.8-127.3-81.6-184.8c-17.7-27.7-28.9-50.5-64-50.5c-31,0-56,23.5-56,52.6v48.1 l-26.3-17.5c-3.6-2.4-5.7-6.4-5.7-10.6V64c0-7.1-5.7-12.8-12.8-12.8h-12.8c-7.1,0-12.8,5.7-12.8,12.8v136.5c0,4.3-2.1,8.3-5.7,10.6 l-26.3,17.5v-48.1c0-29-25.1-52.6-56-52.6c-35.2,0-46.3,22.8-64,50.5C47.9,236,20.4,298.3,3.1,363.3C1,371.1,0,379,0,387 c0,49,50,84.4,100.2,70.9l47.6-12.8c33.7-9,57-38,57-70.9v-70l-68.7,45.8c-2.9,2-6.9,1.2-8.9-1.8c0,0,0,0,0,0l-7.1-10.6 c-2-2.9-1.2-6.9,1.8-8.9c0,0,0,0,0,0L256,239.4l134.1,89.4c2.9,2,3.7,5.9,1.8,8.9c0,0,0,0,0,0l-7.1,10.6c-2,2.9-5.9,3.7-8.9,1.8 c0,0,0,0,0,0l-68.7-45.8v70c0,32.9,23.3,61.8,57,70.9l47.6,12.8C462,471.4,512,436,512,387C512,379,511,371.1,508.9,363.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTissue);
export default __webpack_public_path__ + "static/media/Tissue.128dfb08590bd48986e2b4edcf1ef97e.svg";
export { ForwardRef as ReactComponent };